import styled from 'styled-components';
import ReactSelect from 'react-select';
import PropTypes from 'prop-types';

import colors from 'themes/Main';
import { styledScroll } from 'styles/styledScroll';

const { gray01, gray03, gray04, gray05, gray06, white } = colors;

const shadow =
  '0px 3px 5px rgba(219, 219, 219, 0.2), 0px 1px 18px rgba(219, 219, 219, 0.12), 0px 6px 10px rgba(219, 219, 219, 0.14)';
const shadowIsActive = `0 6px 10px ${gray04}, 0 12px 20px ${gray06}`;

const customStyles = {
  control: (base, { isDisabled }) => ({
    ...base,
    width: '100%',
    height: 'auto',
    minHeight: '40px',
    backgroundColor: isDisabled ? `${gray05}` : 'transparent',
    opacity: isDisabled ? '0.6' : '',
    padding: '0 4px',
    border: `1px solid ${gray03}`,
  }),
  input: () => ({
    color: `${gray01}`,
    fontSize: 14,
  }),
  placeholder: defaultStyles => ({
    ...defaultStyles,
    color: `${gray05}`,
    fontSize: 14,
  }),
  dropdownIndicator: () => ({
    color: `${gray03}`,
    marginTop: '-3px',
    marginLeft: '3px',
  }),
  menu: base => ({
    ...base,
    styledScroll,
    zIndex: 20,
  }),
  singleValue: () => ({
    fontSize: 14,
    color: `${gray01}`,
    whiteSpace: 'nowrap !important',
    overflow: 'hidden !important',
    textOverflow: 'ellipsis !important',
  }),
  multiValue: base => ({
    ...base,
    backgroundColor: `${gray05}`,
    color: `${gray01}`,
  }),
};

const secondaryStyles = {
  control: (base, { isFocused, isDisabled }) => ({
    ...base,
    width: '100%',
    height: '50px',
    opacity: isDisabled ? '0.6' : '',
    backgroundColor: white,
    padding: '0 4px',
    border: 'none',
    borderRadius: 5,
    boxShadow: isFocused ? shadowIsActive : shadow,
    transition: 'all 250ms ease-in-out',
    fontSize: 14,
  }),
  input: () => ({
    color: `${gray01}`,
    fontSize: 14,
  }),
  placeholder: defaultStyles => ({
    ...defaultStyles,
    color: `${gray05}`,
    fontSize: 14,
  }),
  dropdownIndicator: () => ({
    color: `${gray03}`,
    marginTop: '-3px',
    marginLeft: '3px',
    border: 'none',
    borderRadius: 0,
  }),
  menu: base => ({
    ...base,
    borderRadius: 0,
    fontSize: 14,
    zIndex: 20,
  }),
  indicatorSeparator: () => ({ border: 'none' }),
};

export const Container = styled.div``;

export const Select = styled(ReactSelect).attrs(({ hasSecondaryStyle }) => ({
  styles: hasSecondaryStyle ? secondaryStyles : customStyles,
}))``;

Select.defaultProps = {
  hasSecondaryStyle: false,
};

Select.propTypes = {
  hasSecondaryStyle: PropTypes.bool,
};
